// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
// };
const firebaseConfig = {
  apiKey: "AIzaSyDI4F1WvSZxJu1nozEBhZwyGpBdkpUl9dk",
  authDomain: "ecomproject-894a0.firebaseapp.com",
  projectId: "ecomproject-894a0",
  storageBucket: "ecomproject-894a0.appspot.com",
  messagingSenderId: "664959478231",
  appId: "1:664959478231:web:e528cb237c61b41ca1c392",
};

export default firebaseConfig;
